const botIds = [
  '4a68130f-a04d-4ed0-b828-60f17bd68db3',
  'a1ee71da-920f-4118-8b67-c7d9d12d7852',
  'b13d1783-c572-4a01-aff6-e9d833f5788e',
  '3ff81b8e-24db-4a61-b5a7-5fc601aa69ad',
  '84f78d20-fd78-4d4a-badd-649e9e990484'
]

export default botIds
